import React from "react";
import axios from "axios";
import injectSheet from "react-jss";
import Icon from "../../assets/icons/Icon";
import GetData from "../../utils/axios/GetData";
import classNames from "classnames";
import { globalTheme } from "../../styles/globalTheme";
import { getLabelFromView } from "../../utils/helpers";

const checked = <Icon type="check" width="16px" />;

class SingleSelect2 extends React.Component {
  state = {
    style: null,
    rotate: -90,
    elements: this.props.elements ? this.props.elements : [],
    shouldFilter: this.props.shouldFilter || false,
    items: this.props.items || [],
    parentStyle: null,
    focusedElement: 0,
  };

  async componentDidMount() {
    if (this.props.onRef) this.props.onRef(this);
    document.addEventListener("click", this.handleOutsideClick, false);
    await this.getElements();
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if (newProps.elements && newProps.elements !== this.state.elements) {
      if (
        !this.props.closedOnNewElements &&
        newProps.elements.length !== this.state.elements.length
      ) {
        this.setState({
          style:
            newProps.elements.length === 0
              ? null
              : {
                  maxHeight:
                    newProps.elements.length > 3 && !newProps.fullHeight
                      ? "155px"
                      : newProps.addExtraHeight
                      ? newProps.elements.length * 46 +
                        newProps.extraHeight +
                        "px"
                      : newProps.elements.length * 46 + "px",
                  // height:
                  //   newProps.elements.length > 3 && !newProps.fullHeight
                  //     ? "155px"
                  //     : newProps.elements.length * 46 + "px",
                  borderWidth: "1px",
                  overflowY:
                    newProps.elements.length > 3 && !newProps.fullHeight
                      ? "scroll"
                      : "hidden",
                  pointerEvents: "auto",
                },
        });
      }
      if (this.props.shouldFilter) {
        let searchFilters = [];
        if (this.props.items && this.props.items.length > 0) {
          this.props.items.map((x) =>
            searchFilters.push(x.samverkanspartGrupp)
          );
        }

        let filteredData = newProps.elements.filter(
          (x) =>
            !searchFilters.includes(searchFilters.find((el) => el.id === x.id))
        );
        this.setState({ elements: filteredData });
      } else {
        this.setState({ elements: newProps.elements });
      }
    }
  }
  componentWillUnmount() {
    if (typeof this._source !== typeof undefined) {
      this._source.cancel("Operation canceled due to new request.");
    }
    document.removeEventListener("click", this.handleOutsideClick, false);
  }
  setStyle = () =>
    this.setState({
      style: !this.state.style
        ? {
            maxHeight:
              this.props.elements.length > 3 && !this.props.fullHeight
                ? "155px"
                : this.props.addExtraHeight
                ? this.props.elements.length * 46 +
                  this.props.extraHeight +
                  "px"
                : this.props.elements.length * 46 + "px",
            // height:
            //   this.state.elements.length > 3 && !this.props.fullHeight
            //     ? "155px"
            //     : this.state.elements.length * 46 + "px",
            borderWidth: "1px",
            overflowY:
              this.state.elements.length > 3 && !this.props.fullHeight
                ? "scroll"
                : "hidden",
            pointerEvents: "auto",
          }
        : null,
      rotate: !this.state.style ? 90 : -90,
    });

  handleOutsideClick = (e) => {
    if (this.modal) {
      if (!this.modal.contains(e.target)) {
        this.setState({ style: null, rotate: -90, focusedElement: 0 });
        if (this.props.handleClosePopup) {
          this.props.handleClosePopup();
        }
      }
    }
  };

  handleKeyDown = (e) => {
    var index = this.state.focusedElement;

    // UP ARROW
    if (e.keyCode === 38) {
      e.preventDefault();
      if (index === 0 || index === -1) {
        index = this.state.elements.length;
      }
      this.setState({ focusedElement: index - 1 }, function () {
        this.refs[this.props.name + this.state.focusedElement].focus();
      });
    }

    // DOWN ARROW
    if (e.keyCode === 40) {
      e.preventDefault();
      if (index === this.state.elements.length - 1) {
        index = -1;
      }
      this.setState({ focusedElement: index + 1 }, function () {
        this.refs[this.props.name + this.state.focusedElement].focus();
      });
    }

    // ENTER or SPACE
    if (e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault();
      if (this.state.focusedElement === -1) {
        this.handleNew();
      } else {
        if (this.props.multiselect) {
          this.setState(
            { style: null, rotate: -90, parentStyle: null, focusedElement: 0 },
            function () {
              if (this.openbutton) {
                this.openbutton.focus();
              }
              if (this.props.handleEscape) {
                this.props.handleEscape();
              }
            }
          );
        } else {
          this.setValue({
            currentTarget: {
              value:
                this.refs[this.props.name + this.state.focusedElement].value,
              name: this.props.name,
            },
            target: {
              value:
                this.refs[this.props.name + this.state.focusedElement].value,
              name: this.props.name,
            },
          });
        }
      }
    }

    // TAB
    // if (e.keyCode === 9) {
    //   e.preventDefault();
    //   if (this.newButton) {
    //     this.setState({ focusedElement: -1, parentStyle: null }, () =>
    //       this.newButton.focus()
    //     );
    //   }
    // }

    // ESACPE
    if (e.keyCode === 27) {
      e.preventDefault();
      this.setState(
        { style: null, rotate: -90, parentStyle: null, focusedElement: 0 },
        function () {
          if (this.openbutton) {
            this.openbutton.focus();
          }
          if (this.props.handleEscape) {
            this.props.handleEscape();
          }
        }
      );
    }
  };
  // handleFocus = () => {
  //   //Focus on first element of the dropdown
  //   // if (!this.props.noStyleOnFocus) {
  //   //   this.setState({
  //   //     parentStyle: {
  //   //       id: Number(e.currentTarget.value),
  //   //       style: {
  //   //         backgroundColor: this.props.backgroundColor
  //   //           ? this.props.backgroundColor
  //   //           : "whitesmoke",
  //   //       },
  //   //     },
  //   //   });
  //   // }
  // };
  focus() {
    if (!this.refs[this.props.name + "0"]) return;
    this.refs[this.props.name + "0"].focus();
    this.scrollcontainer.scrollTop = 0;
  }
  setFocusOnInput = () => {
    if (this.openbutton) this.openbutton.focus();
  };
  getElements = async () => {
    if (this.state.elements.length > 0) return;
    if (!this.props.url) return;
    if (typeof this._source !== typeof undefined) {
      this._source.cancel("Operation canceled due to new request.");
    }
    this._source = axios.CancelToken.source();
    const data = await GetData(this.props.url, this._source);
    if (data) {
      if (this.state.searchFilters.length > 0) {
        let filteredData = data.filter(
          (x) =>
            !this.state.searchFilters.includes(
              this.state.searchFilters.find((el) => el.id === x.id)
            )
        );
        this.setState({ elements: filteredData });
      } else {
        this.setState({ elements: data });
      }
    }
  };

  handleButtonKeyDown = (e) => {
    if (e.keyCode === 13) {
      //enter
      e.preventDefault();
      return;
    }

    if (e.keyCode === 40 && e.altKey) {
      //pil ner
      this.focus();
      this.setStyle();
    }
  };
  setValue = async (e) => {
    let val = this.state.elements.find(
      (elem) => elem.id === Number(e.currentTarget.value)
    );
    if (!val)
      val = this.state.elements.find(
        (elem) => elem.id === e.currentTarget.value
      );
    if (this.props.multiselect) {
      var values =
        this.props.value && Array.isArray(this.props.value)
          ? this.props.value
          : [];
      const exists = values.find((x) => x.id === val.id);
      if (exists) {
        if (this.props.handleDelete)
          this.props.handleDelete(val, this.props.name);
        else {
          values = values.filter((x) => x.id !== val.id);
        }
      } else {
        if (this.props.handleAdd)
          this.props.handleAdd(val, this.props.name, true);
        else {
          values.push(val);
        }
      }
    } else {
      this.setState({ style: null, rotate: -90, focusedElement: 0 });
      if (this.props.handleEventChange) this.props.handleEventChange(e);
      else this.props.handleValueNameChange(val, this.props.name);
    }
  };
  handleNew = () => this.props.handleNew();

  getCustomItem = (from, element) => {
    switch (from) {
      case "searchNavbar":
        return (
          <div>
            <div style={{ flexGrow: 3, fontSize: "15px" }}>{element?.namn}</div>
            <div
              style={{
                flexGrow: 3,
                fontSize: "13px",
                fontWeight: "400",
              }}
            >
              {getLabelFromView(element?.viewType, element?.listType)}
            </div>
          </div>
        );
      case "searchByName":
        return (
          <div>
            <div style={{ flexGrow: 3, fontSize: "15px", marginBottom: "5px" }}>
              {element?.person?.personnummer}
              {element?.person?.personnummer && element?.namn && ", "}
              {element?.namn}
            </div>
            <div
              style={{
                flexGrow: 3,
                fontSize: "13px",
                marginBottom: "5px",
                fontWeight: "400",
              }}
            >
              {element?.person?.adress || element?.person?.adress2}&nbsp;
              {element?.person?.postnr || element?.person?.postnr2}&nbsp;
              {element?.person?.ort || element?.person?.ort2}
            </div>
            <div style={{ flexGrow: 3, fontSize: "13px", fontWeight: "400" }}>
              {element?.person?.epost}
              {element?.person?.epost && element?.person?.tele && ", "}
              {element?.person?.tele}
            </div>
          </div>
        );
      default:
        return;
    }
  };

  render() {
    const { classes, children, className, outerClassName } = this.props;
    const type = this.props.multi ? "checkbox" : "radio";
    if (this.props.labelIfSingleResult && this.state.elements.length === 1)
      return (
        <div
          className={classes.button}
          style={{
            border: 0,
            fontSize: "16px",
            backgroundColor: "transparent",
            paddingLeft: 0,
          }}
        >
          {this.state.elements[0].namn}
        </div>
      );

    return (
      <div
        ref={(node) => (this.modal = node)}
        className={outerClassName && outerClassName}
      >
        <button
          className={classNames(classes.openButton, className)}
          ref={(node) => (this.openbutton = node)}
          disabled={this.state.elements.length === 0 || this.props.disabled}
          onKeyDown={this.handleButtonKeyDown}
          onClick={(e) => {
            e.preventDefault();
            this.focus();
            this.setStyle();
          }}
        >
          {children ? (
            children
          ) : (
            <div className={classNames(classes.button, this.props.className)}>
              <div className={classes.valueContainer}>
                {fixName(this.props.value, this.props.placeholder)}
              </div>
              <div style={{ display: "flex" }}>
                {this.props.multiselect &&
                this.props.value &&
                this.props.value.length > 1 ? (
                  <div style={{ marginRight: "10px", flex: 1 }}>
                    {"+" + (this.props.value.length - 1) + " st"}
                  </div>
                ) : null}
                <Icon type="arrow" rotate={this.state.rotate} width="16px" />
              </div>
            </div>
          )}
        </button>
        <div
          className={classNames(
            classes.popup,
            this.props.popupClasses && this.props.popupClasses
          )}
        >
          <div className={classes.listContainer} onKeyDown={this.handleKeyDown}>
            <div
              style={this.state.style}
              className={classNames(
                classes.list,
                this.props.customSearchItem?.className &&
                  this.props.customSearchItem?.className
              )}
              ref={(ref) => (this.scrollcontainer = ref)}
            >
              {this.state.elements &&
                this.state.elements.map((element, index) => (
                  <React.Fragment key={index}>
                    {element?.spacer ? (
                      <div style={{ border: "1px solid white" }} />
                    ) : (
                      <label
                        key={index}
                        style={
                          this.state.parentStyle &&
                          this.state.parentStyle.id === element.id
                            ? this.state.parentStyle.style
                            : null
                        }
                        className={classes.listitem}
                      >
                        <input
                          tabIndex="-1"
                          type={type}
                          ref={this.props.name + index}
                          name={this.props.name}
                          value={element.id}
                          checked={
                            isSelected(this.props.value, element.id) !== null
                          }
                          onChange={this.setValue}
                        />
                        {element.icon && (
                          <div style={{ marginRight: "12px" }}>
                            {element.icon}
                          </div>
                        )}
                        {this.props.customSearchItem?.from ? (
                          <>
                            {this.getCustomItem(
                              this.props.customSearchItem?.from,
                              element
                            )}
                          </>
                        ) : (
                          <div
                            tabIndex={this.state.style ? "0" : "-1"}
                            style={{ flexGrow: 3 }}
                          >
                            {element.namn}
                          </div>
                        )}
                        <div
                          style={{
                            width: "16px",
                            height: "16px",
                            objectFit: "contain",
                          }}
                        >
                          {isSelected(this.props.value, element.id)}
                        </div>
                      </label>
                    )}
                  </React.Fragment>
                ))}
            </div>
            {this.props.customButton &&
              this.state.elements.length >
                this.props.customButton.requirements && (
                <button
                  ref={(ref) => (this.newButton = ref)}
                  className={classes.newButton}
                  onClick={this.props.customButton.action}
                >
                  {this.props.customButton.label}
                </button>
              )}
            {this.state.elements.length === 0 ||
              (this.props.showNewButton && (
                <button
                  ref={(ref) => (this.newButton = ref)}
                  className={classes.newButton}
                  onClick={this.handleNew}
                >
                  Skapa ny
                </button>
              ))}
          </div>
        </div>
      </div>
    );
  }
}
const styles = (theme) => ({
  openButton: {
    backgroundColor: "transparent",
    border: 0,
    display: "block",
    width: "100%!important",
    maxWidth: "300px",
    padding: (props) => (props.padding ? props.padding : 0),
    fontWeight: 500,
    "&:disabled": {
      cursor: "auto",
      backgroundColor: "transparent",
      "&:hover": {
        backgroundColor: "transparent",
      },
      "& svg g circle": {
        fill: "#8f919d!important",
      },
    },
    "&:focus": {
      outline: (props) => (props.noFocus ? null : globalTheme.outline),
    },
  },
  button: {
    backgroundColor: "white",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: "4px",
    border: "solid 1px #cbd2dc",
    fontSize: "14px",
    lineHeight: 1,
    padding: "11px 8px 11px 12px",
    textAlign: "left",
  },
  newButton: {
    display: "block",
    width: "100%",
    backgroundColor: "white",
    border: 0,
    borderTop: "1px solid #dbe0e8",
    padding: "6px 0",
    fontSize: "14px",
    fontWeight: 500,
    color: "#335cda",
    "&:hover": {
      color: "black",
    },
    "&:focus": {
      color: "black",
      backgroundColor: "whitesmoke",
    },
  },
  valueContainer: {
    flex: 1,
    marginRight: "10px",
    lineHeight: "1.14",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  popup: {
    position: "relative",
    width: "100%",
    height: "100%",
  },
  listContainer: {
    right: (props) => props.right,
    left: (props) => props.left,
    top: (props) => (props.top ? props.top : 0),
    position: "absolute",
    width: (props) => (props.width ? props.width : "200px"),
    minWidth: "300px",
    zIndex: "10000",
    backgroundColor: "#182d58",
    borderRadius: "3px",
    boxSizing: "border-box",
    boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0), 0 6px 16px 0 rgba(0, 0, 0, 0.1)",
    border: "solid 0 #dbe0e8",
  },
  list: {
    position: "relative",
    maxHeight: 0,
    pointerEvents: "none",
    overflow: "hidden",
    transition: "max-height 0.15s ease-out",
  },
  listitem: {
    padding: "14px 18px",
    borderBottom: "1px solid ",
    cursor: "pointer",
    margin: 0,
    borderColor: (props) => (props.borderColor ? props.borderColor : "#dbe0e8"),
    backgroundColor: (props) =>
      props.backgroundColor ? props.backgroundColor : "white",
    color: (props) => (props.color ? props.color : "inherit"),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& div": {
      "&:focus": {
        outline: globalTheme.outline,
        outlineOffset: "4px",
      },
    },
    "& input": {
      position: "absolute",
      opacity: 0,
      cursor: "pointer",
    },
    "&:hover": {
      backgroundColor: theme.themeHoverColor,
      color: theme.themeHoverTextColor,
      "& svg g polygon": {
        fill: `${theme.themeHoverTextColor}!important`, //"#8f919d!important",
      },
      "& svg path": {
        fill: `${theme.themeHoverTextColor}!important`, //"#8f919d!important",
      },
      "& svg rect": {
        fill: `${theme.themeHoverTextColor}!important`, //"#8f919d!important",
      },
    },
    "& svg": {
      display: "block",
      fill: theme.themeColor,
      width: "18px",
      height: "18px",
    },
    "&:last-child": {
      border: 0,
    },
  },
  "@media(max-width: 1023px)": {
    button: {
      backgroundColor: (props) =>
        props.buttonColor ? props.buttonColor : "transparent",
      border: (props) => (props.buttonBorder ? props.buttonBorder : 0),
      textAlign: "inherit",
      fontSize: (props) => (props.fontSize ? props.fontSize : "14px"),
    },
    listContainer: {
      minWidth: "100%",
    },
  },
});
function isSelected(val, id) {
  if (!val) return null;
  if (Array.isArray(val)) {
    const exists = val.find((x) => x.id === id);
    return exists ? checked : null;
  } else {
    return val.id === id ? checked : null;
  }
}
function fixName(val, placeholder) {
  if (!val) return placeholder;
  let value = val.namn;
  if (Array.isArray(val)) {
    value = val.length > 0 ? val[0].namn : null;
  }
  return value ? value : placeholder;
}
export default injectSheet(styles)(SingleSelect2);
